import React, { useState } from "react";
import ResizableCell from "../../Utility/ResizableCell";
import { Link, useNavigate, useParams } from "react-router-dom";
import { getUrlFromS3 } from "../api";
import useDownloader from "react-use-downloader";
import { toast } from "react-toastify";

export default function SalesTableV1({ reports, restName }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [editableCell, setEditableCell] = useState(null);
  const { size, elapsed, percentage, download, cancel, error, isInProgress } =
    useDownloader();

  if (!reports || reports.length === 0) {
    return <p className="text-center">No reports available</p>;
  }
  const oheaders = Object.keys(reports[0]).filter(
    (key) => key !== "_id" && key !== "report_id"
  );
  console.log(oheaders);
  const desiredOrder = [
    "total_discount",
    "total_sales",
    "net_sales",
    "date",
  ];

  const headers = desiredOrder.filter((header) => oheaders.includes(header));


  const downloadHandler = async (restaurant_id, report_date, report_type) => {
    try {
      const response = await getUrlFromS3(
        restaurant_id,
        report_date,
        report_type
      );
      if (response?.file_url === undefined) {
        toast.error("File not available");
        return;
      }
      download(response.file_url, response.file_name);
    } catch (error) {
      toast.error("File not available");
    }
  };

  return (
    <div style={{ overflowX: "auto" }}>
      <table className="table table-striped table-hover table-bordered shadow-sm table-responsive table-stack">
        <thead>
          <tr>
            {headers.map((header) => (
              <th
                key={header}
                style={{
                  textAlign: "center",
                  textTransform: "capitalize",
                  verticalAlign: "middle",
                }}
              >
                <ResizableCell>{header.replace(/_/g, " ")}</ResizableCell>
              </th>
            ))}
            <th
              style={{
                textAlign: "center",
                textTransform: "capitalize",
                verticalAlign: "middle",
              }}
            >
              QBO Status
            </th>
            <th
              style={{
                textAlign: "center",
                textTransform: "capitalize",
                verticalAlign: "middle",
              }}
            >
              clickBACON Status
            </th>
            <th
              style={{
                textAlign: "center",
                textTransform: "capitalize",
                verticalAlign: "middle",
              }}
            >
              Sales Receipt
            </th>
          </tr>
        </thead>
        <tbody>
          {reports.map((row) => (
            <React.Fragment key={row._id}>
              <tr style={{ cursor: "pointer" }}>
                {headers.map((header) => (
                  <td
                    data-label={header.replace(/_/g, " ")}
                    style={{
                      textAlign: "center",
                    }}
                    key={header}
                    onClick={() => {
                      navigate(
                        `/restaurants/reports/report-details/${row.report_id}`
                      );
                    }}
                  >
                    {editableCell === row._id ? (
                      <input
                        className="form-control"
                        type="text"
                        defaultValue={row[header]}
                        onChange={(e) => {}}
                      />
                    ) : typeof row[header] === "boolean" ? (
                      row[header] ? (
                        "Yes"
                      ) : (
                        "No"
                      )
                    ): header === "total_discount" ? (
                    row[header].toFixed(2)
                    ) : header === "verification_status" ? (
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        {row["menu_verified"] === false && (
                          <p className="text-danger my-0">Menu</p>
                        )}
                        {row["labor_verified"] === false && (
                          <p className="text-danger my-0">Labor</p>
                        )}
                        {row["discount_verified"] === false && (
                          <p className="text-danger my-0">Discount</p>
                        )}
                        {row["unassigned_labor_issue"] === true && (
                          <p className="text-danger my-0">Unassigned Labor</p>
                        )}
                      </div>
                    ) : header === "report_issues" ? (
                      <div style={{ display: "flex", flexDirection: "column" }}>
                      {row["sales_issue"] === true && (
                        <p className="text-danger my-0">Sales</p>
                      )}
                      {row["discount_issue"] === true && (
                        <p className="text-danger my-0">Discount</p>
                      )}
                      {row["labor_issue"] === true && (
                        <p className="text-danger my-0">Labor</p>
                      )}
                    </div>
                    ) : (
                      row[header]
                    )}
                  </td>
                ))}
                <td data-label="QBO Status"
                  style={{
                    textAlign: "center",
                    textTransform: "capitalize",
                  }}
                >
                  {row.qbo_status ? "Synced" : "Pending"}
                </td>
                <td data-label="clickBACON Status"
                  style={{
                    textAlign: "center",
                    textTransform: "capitalize",
                  }}
                >
                  {row.clickbacon_status ? "Synced" : "Not Synced"}
                </td>

                <td data-label="Sales Receipt"
                  style={{
                    textAlign: "center",
                  }}
                >
                  <Link
                    to={`/restaurants/${id}/${row.report_id}/sales-receipt/?restaurant_name=${restName}&total_discount=${row.total_discount}&date=${row.date}`}
                  >
                    View Sales Receipt
                  </Link>
                </td>
              </tr>
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
}
